/**
 * UX Sprint 1 — Sub-tab pills for the active user-stage.
 *
 * Shows the existing tab keys that compose the active user-stage,
 * relabeled to the user-facing names defined in USER_STAGES.subTabs.
 * Selecting a pill calls `onSelect(tabKey)` — the parent flips the
 * existing `tab` state, so every existing panel keeps rendering.
 */
import { USER_STAGES } from "@/lib/constants";

export default function StageSubTabs({ userStageKey, activeTab, onSelect }) {
    const us = USER_STAGES.find((s) => s.key === userStageKey);
    if (!us || !us.subTabs || us.subTabs.length <= 1) return null;

    return (
        <div
            data-testid="stage-subtabs"
            className="border-b border-zinc-900 bg-[#070707]"
        >
            <div className="px-4 lg:px-8 overflow-x-auto scrollbar-thin">
                <div className="flex gap-1 min-w-max py-1">
                    {us.subTabs.map((st) => {
                        const isActive = activeTab === st.key;
                        return (
                            <button
                                key={st.key}
                                type="button"
                                data-testid={`subtab-${st.key}`}
                                onClick={() => onSelect && onSelect(st.key)}
                                className={`text-xs px-3 py-2 rounded-sm transition-colors font-mono uppercase tracking-wider ${
                                    isActive
                                        ? "bg-zinc-900 text-white border border-zinc-800"
                                        : "text-zinc-500 hover:text-white hover:bg-zinc-900/50 border border-transparent"
                                }`}
                            >
                                {st.label}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
